import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getGeodeticDatumList as getGeodeticDatumListApi,
	getGeodeticDatumListQuery as getGeodeticDatumListQueryApi,
	getGeodeticDatum as getGeodeticDatumApi,
	addNewGeodeticDatumApi,
	updateGeodeticDatumApi,
	deleteGeodeticDatumApi,
	checkGeodeticDatumExistsApi,
} from '../../helpers/geodetic_datum/api_helper';

export const getGeodeticDatumList = createAsyncThunk(
	'geodeticDatum/getGeodeticDatumList',
	async () => {
		try {
			const response = await getGeodeticDatumListApi();
			// Extract data array from response
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener los datos geodésicos.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getGeodeticDatumListQuery = createAsyncThunk(
	'geodeticDatum/getGeodeticDatumListQuery',
	async params => {
		try {
			const response = getGeodeticDatumListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getGeodeticDatum = createAsyncThunk(
	'geodeticDatum/getGeodeticDatum',
	async geodetic_datum_id => {
		try {
			const response = await getGeodeticDatumApi(geodetic_datum_id);
			return response;
		} catch (error) {
			toast.error('Error al obtener el dato geodésico.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewGeodeticDatum = createAsyncThunk(
	'geodeticDatum/addNewGeodeticDatum',
	async geodetic_datum => {
		try {
			const response = await addNewGeodeticDatumApi(geodetic_datum);
			toast.success('Dato Geodésico agregado exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar el dato geodésico.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateGeodeticDatum = createAsyncThunk(
	'geodeticDatum/updateGeodeticDatum',
	async geodetic_datum => {
		try {
			const response = await updateGeodeticDatumApi(geodetic_datum);
			toast.success('Dato Geodésico actualizado exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar el dato geodésico.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteGeodeticDatum = createAsyncThunk(
	'geodeticDatum/deleteGeodeticDatum',
	async geodetic_datum => {
		try {
			const response = await deleteGeodeticDatumApi(geodetic_datum._id);
			toast.success('Dato Geodésico eliminado exitosamente.', {
				autoClose: 3000,
			});
			// Return the original object to identify which item to remove
			return geodetic_datum;
		} catch (error) {
			toast.error('Error al eliminar el dato geodésico.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkGeodeticDatumExists = createAsyncThunk(
	'geodeticDatum/checkGeodeticDatumExists',
	async name => {
		try {
			const response = await checkGeodeticDatumExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
